module.exports = __webpack_public_path__ + "img/li_normal.fc0ce266.png";